import { assert } from '@Utils/assert';
import uniq from 'lodash/uniq';

export function findByIdForImmutableCollectionFn(requiredId) {
  return function findByIdForImmutableCollection(item) {
    const id = item.get('id');

    return requiredId === id;
  };
}

export function findByIdFromIdsCollectionFn(requiredId) {
  return function findByIdFromIdsCollection(id) {
    return requiredId === id;
  };
}

export function everyForImmutableCollectionFn(prop) {
  return function everyForImmutableCollection(item) {
    return item.get(prop);
  };
}

export function listIdsToListItemsForMapFn(immutableMap) {
  return function mapListIdsToListItems(id) {
    return immutableMap.get(id);
  };
}

export function normalizeItems(items) {
  const result = items.reduce(
    (res, item) => {
      const id = item.id?.toString();

      if (id != null) {
        res.ids?.push(id);
        res.items[id] = item;
      }

      return res;
    },
    {
      items: {},
      ids: [],
    }
  );

  if (!__PROD__) {
    const errorMessageAndPrintInfo = {
      toString() {
        Logger.debug('Check the result:', result, 'from items', items);

        return 'normalized items ids should not contain duplicates';
      },
    };

    assert(uniq(result.ids).length === result.ids.length, errorMessageAndPrintInfo);
  }

  return result;
}

export function createCombinedReducer(reducers) {
  return function combinedReducer(state, action) {
    // eslint-disable-next-line no-shadow
    return reducers.reduce((state, item) => item(state, action), state);
  };
}

export * from './Decorators';
export * from './DOM';
